<template>
  <div 
    :class="'main site-wrapper' + 
      currentRouteNameClass + 
      (has_order_notification ? ' has-order-notification': '') + 
      (hideHeader ? ' no-header' : '') +
      (locationNotice ? ' has-location-notice' : '')
    ">
    
    <!-- loaded mean we need to have business and locaiton active to show these -->
    <template>
      
        <router-view v-if="loaded"/>

        <app-signup-login-option-modal v-if="!is_user_logged_in"/>
        <app-signup-modal v-if="!is_user_logged_in"></app-signup-modal>
        <app-login-modal v-if="!is_user_logged_in"></app-login-modal>
        <app-verifiedemail-modal v-if="!is_user_logged_in"></app-verifiedemail-modal>
        <app-resetpassword-modal v-if="!is_user_logged_in"></app-resetpassword-modal> <!-- reset password form -->
        <app-setlocation-modal/>
        <app-sign-out/>
        <app-snackbar/>
        <app-spinner/>
        <loyality-signup-congratulations v-if="is_user_logged_in && vg_businessLoyality.id && vg_businessLoyality.is_active"/>
        <loyality-referral-congratulations v-if="is_user_logged_in && vg_businessLoyality.id && vg_businessLoyality.is_active"/>
        <loyality-checkin-congratulations v-if="is_user_logged_in && vg_businessLoyality.id && vg_businessLoyality.is_active"/>
        <in-store v-if="!is_user_logged_in & $route.name != 'AddAnonymous'"/>
        <!-- <loyality-signup v-if="vg_businessLoyality.id && vg_businessLoyality.is_active"/>
        -->

        <set-password-notice v-if="is_user_logged_in"/>
        <!-- cart modals available globally, we must have location -->
        <template v-if="$route.name != 'Cart' || $route.name != 'VisitorAgeVerification' ">
          <app-sidebar-cart v-show="show_sidebar_cart"/>
        </template>

        <added-to-cart-recommend-products/> 
        <cart-full></cart-full>
    </template>

    <!-- <div v-else>
      <app-skeleton />
    </div> -->
    
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Env from '@/env';
import moment from 'moment';
import CartApis from '@/Components/Controllers/CartApis';
import UserApis from '@/Components/Controllers/UserApis';
import Helpers from '@/Components/Helpers/Helpers';
import BusinerssProfileApis from '@/Components/Controllers/BusinerssProfileApis';
import LocationApis from '@/Components/Controllers/LocationApis';
import LoginApis from '@/Components/Controllers/LoginApis';
import OrderHistoryApis from '@/Components/Controllers/OrderHistoryApis';
import VboutApis from '@/Components/Controllers/VboutApis';
// Components for cart, now we have cart modal on all pages
import CartFull from '@/Components/Pages/PageComponents/ProductDetail/CartFull';

export default {
  name: 'MainWrapper',
  
  metaInfo() {
    return { 
      title: `${this.vg_businessProfile && this.vg_businessProfile.name ? this.vg_businessProfile.name : ''} Cannabis Store in ${this.vg_selectedStore.address && this.vg_selectedStore.address.city ? this.vg_selectedStore.address.city : 'Canada'}`,
      meta: [
        { name: 'description', content:  `${this.vg_businessProfile && this.vg_businessProfile.name ? this.vg_businessProfile.name : ''} Cannabis Store in ${this.vg_selectedStore.address && this.vg_selectedStore.address.city ? this.vg_selectedStore.address.city : 'Canada'}`,},
        { property: 'og:title', content: `${this.vg_businessProfile && this.vg_businessProfile.name ? this.vg_businessProfile.name : ''} Cannabis Store in ${this.vg_selectedStore.address && this.vg_selectedStore.address.city ? this.vg_selectedStore.address.city : 'Canada'}`,},
      ]
    }
  },

  components: {
    CartFull
  },

  data: () => ({
    drawer: null,
    loaded: false,
    routeWithReSyncLocations: ['HomePage','StoreProfile', 'StoreLanding', 'Cart', 'Checkout', 'LocationProductDetail'],
    routeWithStaticContentOnly: ['FiskaResponse','CloverResponse', 'TermsConditions', 'PrivacyPolicy', 'HelpAndSupport', 'Faqs'],
  }),

  computed: {
    /**
     * Location  Notice
     */
    locationNotice() {
      if(this.vg_selectedStore.contact_details){
        return Helpers.getContactValue(this.vg_selectedStore.contact_details, 'website_notice', 'display_value');
      }
      return '';
    },

    /**
     * Create class for current route
     */
    currentRouteNameClass() {
      return this.$route.name ? (' ' + this.$route.name.toLowerCase() + '-page-main') : '';
    },

    // If hide header present in query 
    hideHeader() {
      return (this.$route.query['noh'] && ( (this.$route.query['noh'] == 1) || (this.$route.query['noh'] == 'true') )   ) ? true : false;
    },

    // Sidebar cart display only if
    show_sidebar_cart() {
      if(this.vg_selectedStore.id && this.vg_businessProfile.id && (this.$route.name != 'Checkout') && (this.$route.name != 'Cart') && (this.$route.name != 'Register')) {
        return true;
      }
      return false;
    },

    // Has order notification
    has_order_notification() {
      if(this.is_user_logged_in && this.vg_orderNotification.show){
        return true;
      }
    },

		isIdle() {
			return this.$store.state.idleVue.isIdle;
		},

    is_user_logged_in()  {
      return this.vg_userId ? this.vg_userId : false;
    },

    kioskMode() {
      return (this.$route.query['kiosk'] && ( (this.$route.query['kiosk'] == 1) || (this.$route.query['kiosk'] == 'true') ) ) ? true : false;
    },

    ...mapGetters({
      vg_cartId: "cart/id",
      vg_selectedStore: "location/selected", 
      vg_pastSelectedStoreId: "location/past_selected_location_id", 
      vg_businessProfile: "businessprofile/detail", 
      vg_userAddress: "location/userAddress",
      //userToken: "getLoggedInUserToken",
      vg_userId: "getLoggedInUserId",
      vg_loggedInUser: "getLoggedInUser",
      vg_currentOrder: "orderhistory/currentOrder",
      //guestLandedTime: "location/guestLandedTime", 
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_cartItems: "cart/cartItems",
      vg_orderNotification: "orderhistory/orderNotification",
      vg_cartSuccessObj: "cart/successObj",
      vg_pendingItemOnCart: "cart/pendingItem",
      vg_businessLoyality: "businessprofile/businessLoyality", 
      vg_locationNearBy: "location/nearby",
    }),
  },

  async created() {
    this.vm_mutatePageLoadUrl(window.location.href);
    
    
     // We dont need any logics or apis for thise pages
    if( this.routeWithStaticContentOnly.includes(this.$route.name) == true ) { 
      this.loaded = true;
      return;
    }

    this.va_setCartId('');
    this.va_setCartDetail({});
    this.va_setCartItems([]);
  
    // ON refresh set business and location emity , save the old location id 
    this.va_resetBusinessProfileDetail();
    if(this.vg_selectedStore.id) {
      this.va_setPastSelectedLocationId(this.vg_selectedStore.id);
    }
    this.va_setSelectedLocation({});

    // Do not trigger anything for homepage because its being handled, on their individual page, 
    // preventing double api trigger
    // let ignoreBusinessFetchForPages =  ['HomePage', 'Cart', 'Checkout', 'StoreLanding', 'StoreProfile', 'SearchProductResult', 'LocationProductDetail', 'EmailPhoneUpdateVerification', 'UserEditAccount', 'UserAccountMembership'];
    // if( ignoreBusinessFetchForPages.indexOf(this.$route.name) > -1 )
    // return;

    // if(this.$route.params.business_slug){
    //   // When ever page refreshes, re fetch business profile and remove old so that we wont see old business logo flash
    //   //this.va_resetBusinessProfileDetail();
    //   let res = await BusinerssProfileApis.fetchBusinessProfile(this.$route.params.business_slug);

    //   // Once business profile changed, auto pull nearest location from watcher
    //   if(res.status != 200){
    //     // if we dont have valid business slug fall back to default
    //     this.va_snackbar({
    //       type: 'warning', 
    //       message: res.response.data.msg,
    //     });
    //     setTimeout(()=> {
    //       // give time to display message
    //       window.location.href = window.location.origin
    //     }, 200)
    //   }
    // }
  },

  beforeDestroy() {
    window.pubnub = null;
  },

  async mounted() {
    const self = this;
    this.va_spinner(false);
    // We dont need any logics or apis for thise pages
    if( this.routeWithStaticContentOnly.includes(this.$route.name) == true ) { 
      return;
    }
    // lets 
    // we need business slug for every page except fiska response
    // If has business slug fetch business details
    if(this.$route.params.business_slug){
      let res = await BusinerssProfileApis.fetchBusinessProfile(this.$route.params.business_slug);
      // set business
     
      if(res.status == 200){
        // If has store slug, fetch store
        if(this.$route.params.store_slug){
          let locationRes = await LocationApis.fetchBySlug(this.$route.params.store_slug);
          if(locationRes.status == 200){
            await this.va_setSelectedLocation(locationRes.data.payload);
            CartApis.locationCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));
            
          } else {
            this.va_setSelectedLocation({});
            // Location not found
            // we are showing notice for storelanding and store profile rest we can redirect to homepage
            let ignoreRedirect = ['StoreLanding', 'StoreProfile'];
            if(ignoreRedirect.indexOf(this.$route.name) == -1 ){
              this.va_snackbar({
                type: "warning",
                message: "Cannot find the store."
              });
              let redirectUrl = self.$router.resolve({ 
                name: 'HomePage',
                params: { 
                  business_slug: this.$route.params.business_slug,
                },
              });
              window.location.href = window.location.protocol + '//' + window.location.host + redirectUrl.href;
            }
          }
        } else {
          // Now route doesnot have location slug so fetch nearest 
          let nearestLocationRes = await LocationApis.fetchNearest(_.isEmpty(this.vg_userAddress) ? '' : this.vg_userAddress.geometry, false);
          // Check the result  
          if(nearestLocationRes.status == 200 && (nearestLocationRes.data.payload.length > 0) ){
            // Now we have store the location id as past location id try to find it , 
              let nearestLocation = nearestLocationRes.data.payload;
              let findLocation = nearestLocation.find( item => item.id == this.vg_pastSelectedStoreId);
              // If no select first one
              if(findLocation == undefined){
                this.va_setSelectedLocation(nearestLocation[0]);
                CartApis.locationCart(nearestLocation[0].id, Helpers.getLocationCartFullUrl(this));
              } else {
                // If found 
                this.va_setSelectedLocation(findLocation);
                CartApis.locationCart(findLocation.id, Helpers.getLocationCartFullUrl(this));
              }
          }
        }
         
      } else {
        if( res.response.status == 404 ) {
          window.location.href = window.location.origin
        } else {
          this.$router.push({
            name: 'Page404'
          })
        }
      }
    }

    // Set the branding color then only set website visible
    await this.setBrandingColors(this.vg_businessProfile);
    this.checkBusinessLoyaltyAndMakeAction();
    this.loaded = true;

    this.vm_mutateInStore(((this.$route.query.in_store == 1) || (this.$route.query.in_store == 'true')) ? 1 : 0);
    // clear filter on mount
    this.va_setEmptySearchFilter();
  
    // this are not the pages then on route change
    await this.triggerPubNobChannel({ subscribeChannel: false });

    if( (this.$route.name == 'HomePage') && this.is_user_logged_in ){
      if(this.vg_selectedStore.id || this.vg_pastSelectedStoreId) {
        Helpers.unsubscribePubnubLocationUser({
          user_id: this.vg_userId,
          location_id: this.vg_selectedStore.id ? this.vg_selectedStore.id : this.vg_pastSelectedStoreId,
        });
      }
    }
    
    // If we have in_store true or 1 in route check if user is not logged in to emit anonymous model , must not be AddAnonymous, route
    if( !this.is_user_logged_in && !this.$route.query.signup_token 
    && this.$route.name != 'LoginWithToken' 
    && this.$route.name != 'LoginWithUserAuthToken' 
    && this.$route.name != 'AddAnonymous' 
    && ((this.$route.query.in_store == 1) || (this.$route.query.in_store == 'true')) ){
      bus.$emit('in-store-modal', true)
    } 

    // Check if url has verify_email, and user must not be logged in
    if( (this.$route.query.verify_email == 'true') && this.$route.query.token){
      if(this.is_user_logged_in){
        return false; // do not show anything
      }
      this.va_spinner(true);
      let verifyEmailres = await LoginApis.verifyEmail({
        token: self.$route.query.token,
        site_url: window.location.protocol + '//' + window.location.host + this.$route.path,
        set_password: self.$route.query.set_password ? true : false,
        // Need to Add
        business_id: this.vg_businessProfile.id,
        business_name: this.vg_businessProfile.name,
        business_slug: this.$route.params.business_slug,
        logo_url: (this.vg_businessProfile && this.vg_businessProfile.branding && this.vg_businessProfile.branding.logo_url) ? this.vg_businessProfile.branding.logo_url : '',
        location_id: this.vg_selectedStore.id ? this.vg_selectedStore.id: '',
        location_slug: this.vg_selectedStore.slug ? this.vg_selectedStore.slug : '',
      });

      if(verifyEmailres.status == 200){
        // This is show green notificaiton bar
        self.va_setEmailVerified(true);
        await self.setLoginSuccessUserData(verifyEmailres);
        self.va_snackbar({
          type: 'success', 
          message: 'You are logged in.',
        });

        // Now after email verify check for if set_password = true
        if(self.$route.query.set_password == 'true'){
          self.vg_setPasswordObj({
            modal: true,
            token: verifyEmailres.data.payload.reset_password_token,
          })
        }

        // only hit api do not show modal 
        if(this.vg_businessLoyality.id && this.vg_businessLoyality.is_active) {
          let userCheckInres = await UserApis.userLoyalityCheckIn(this.vg_businessProfile.id, this.vg_selectedStore.id, this.vg_selectedStore.name); 
          if(userCheckInres.status == 200){
            // alert modal
            bus.$emit('loyality-checkin-congratulations', {
              modal: true,
              point: userCheckInres.data.payload.points_earned,
              message: "You've checked in!",
            })
            // fetch user points
            this.va_setUserLoyalityObj({
              user_id: this.vg_userId, 
              business_id: this.vg_businessProfile.id,
            });
          }
        } 
        self.va_spinner(false);
      } else {
        self.va_spinner(false);
        self.va_snackbar({
          type: 'error', 
          message: verifyEmailres.response.data.msg,
        });
      }
    } 

    // If user is not logged in and in url there is signup 1 or true
    if( !this.vg_userId && ((this.$route.query.signup == 'true') || (this.$route.query.signup == 1)) ){
      this.va_setSignupModal(true);
    }
    // this.loaded = true;
  },

  watch:{
    /**
     * Watch for business id change
     */
    'vg_businessProfile.id': {
      handler: async function(val) {
        
       // If we dont have location id and on route there is no store slug then assign first location 
       // if(!val && (!this.$route.params.store_slug || (this.$route.params.store_slug == undefined) ) ){
          
        //  let nearestLocation = await LocationApis.fetchNearest(_.isEmpty(this.vg_userAddress) ? '' : this.vg_userAddress.geometry, false);
        //   if(nearestLocation.status == 200 && (nearestLocation.locations.length > 0) ){
        //     await this.va_setSelectedLocation(nearestLocation.locations[0]);
        //     // get the cart item
        //     CartApis.locationCart(nearestLocation.locations[0].id, Helpers.getLocationCartFullUrl(this));
        //   }
          // specially doing this for pages not having location slug and user change business slug hard on url
          //if(!this.$route.params.store_slug || (this.$route.params.store_slug == undefined)){
            // ONly search for nearest when there is no location slug in url
            // await LocationApis.fetchNearest(_.isEmpty(this.vg_userAddress) ? '' : this.vg_userAddress.geometry);
            // if(this.vg_selectedStore.id && (this.vg_locationNearBy.locations.length > 0)){
            //   let findLocation = this.vg_locationNearBy.locations.find( item => item.id == this.vg_selectedStore.id);
            //   if(findLocation == undefined){
            //     this.va_setSelectedLocation(this.vg_locationNearBy.locations[0]);
            //     // fetch cart
            //     CartApis.locationCart(this.vg_locationNearBy.locations[0].id, Helpers.getLocationCartFullUrl(this));
            //   } 
            // } else if (!this.vg_selectedStore.id && (this.vg_locationNearBy.locations.length > 0)){
            //   this.va_setSelectedLocation(this.vg_locationNearBy.locations[0]);
            //   CartApis.locationCart(this.vg_locationNearBy.locations[0].id, Helpers.getLocationCartFullUrl(this));
            // }
          // }
          // If business id is changed mean we need to hit loyalty subscription
          // if logged in and business changed
        // }

        // If we have business then check for the subscription, if user is logged in
          // if(val && this.vg_loggedInUser && this.vg_loggedInUser.id && this.vg_businessLoyality.id && this.vg_businessLoyality.is_active){
          //   console.log('add loyalty obj' + this.vg_businessLoyality.is_active)
          //   this.checkUserBusinessLoyaltySubscription({ user_id: this.vg_loggedInUser.id });
          // } 
          // if((this.vg_businessLoyality.is_active == undefined) || (this.vg_businessLoyality.is_active == false) ){
          //   console.log('free loyalty obj')
          //   this.va_setUserLoyalityObj({});
          // }
          // on mound app mounted will trigger for verify first time else in watcher this will take a watch
          if(this.loaded) {
            this.checkBusinessLoyaltyAndMakeAction();
          }


      },
    },

    '$route': async function (to, from) {
      
      // On route change emit user activity, validation done on method itself
      // on change route 
      // we reset location for landing, shop, cart, checkout , rest same so except those
      if( (this.routeWithReSyncLocations.includes(to.name) == false) && this.is_user_logged_in) {
        // this are not the pages then on route change
        Helpers.emitUserActivity();
      }

      if( (to.name == 'HomePage') && this.is_user_logged_in ){
        Helpers.unsubscribePubnubLocationUser({
          user_id: this.vg_userId,
          location_id: this.vg_selectedStore.id ? this.vg_selectedStore.id : this.vg_pastSelectedStoreId,
        });
      }
      // On route change check whther user is logged in for a year
      if(this.$store.getters.getLoggedInUserDate && this.$store.getters.getLoggedInUserToken){
        let loggedInDate = moment(this.$store.getters.getLoggedInUserDate).valueOf();
        let expdate = moment().valueOf();
        if( expdate-loggedInDate >= 61536000000){ 
          this.va_snackbar({
            type: 'success', 
            message: 'Session expired.. Please login again..',
          });
          this.signOut();
        }
      }

      // On change route scroll to top of page
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      // If route is not search product result or search result page reset filters
      let routeNotToClearFilters = ['SearchProductResult', 'StoreProfile', 'StoreLanding', 'LocationProductDetail'];
      // Clear filte except this routes
      if(routeNotToClearFilters.indexOf(this.$route.name) < 0 ){
        this.va_setEmptySearchFilter();
      }
    },

    'vg_selectedStore': async function(val, old) { 

      if(val.id && this.is_user_logged_in){
        // CartApis.locationCart(val.id, Helpers.getLocationCartFullUrl(this));
         // only unsubscribe if current location id do not macth with past
        if(this.is_user_logged_in && window.pubnub && this.vg_pastSelectedStoreId && (this.vg_pastSelectedStoreId != val.id)){
          // If user logged in then user might have subscribe for past location, lets unsubscribe
          //let subscribedChannels = window.pubnub.getSubscribedChannels();
          // let oldChannel = this.vg_pastSelectedStoreId + '-user';
          // console.log('unsubscribe past location -> ' + oldChannel)
          let vboutAddUser = await VboutApis.upsertUser(this.vg_loggedInUser, val.id);
          if(vboutAddUser && (vboutAddUser.status == 201) ){
            VboutApis.addUserTag({
              email: this.vg_loggedInUser.email,
              tagname: 'verified',
            }, val.id);
          }
          
          Helpers.unsubscribePubnubLocationUser({
            user_id: this.vg_userId,
            location_id: this.vg_pastSelectedStoreId,
          });
          // trigger with new location id
        }
        // let subscribedChannels = window.pubnub.getSubscribedChannels();
        // console.log('subscribed channels ')
        // console.log(subscribedChannels)
        // await this.triggerPubNobChannel();
      }

      if(_.isEmpty(val)){
        return;
      }
      // loyality congraluations removed
      // Location is always fetched after business is fetched so lets check user loyality checked infor all pages
      // user must be verified email user
      if( this.vg_businessProfile.id && this.vg_businessLoyality.id && this.vg_businessLoyality.is_active && this.vg_userId && ( (this.$route.query.in_store == 1) || (this.$route.query.in_store == 'true') )){
        // only hit api do not show modal 
        let userCheckInres = await UserApis.userLoyalityCheckIn(this.vg_businessProfile.id, this.vg_selectedStore.id, this.vg_selectedStore.name); 
        if(userCheckInres.status == 200){
          // alert modal
          bus.$emit('loyality-checkin-congratulations', {
            modal: true,
            point: userCheckInres.data.payload.points_earned,
            message: "You've checked in!",
          })
          // fetch user points
          this.va_setUserLoyalityObj({
            user_id: this.vg_userId, 
            business_id: this.vg_businessProfile.id,
          });
        }
      }
    },

    is_user_logged_in: {
      handler: function (val) {
        if(val) {
          window.pubnub.setUUID(this.vg_userId);
          this.triggerPubNobChannel({ subscribeChannel: true });
          Helpers.emitUserActivity();
        } else {
           window.pubnub.setUUID('budler_web_app');
        }
      },
      deep: true
    },

    'vg_businessProfile': {
       handler: function (val) {
        this.setBrandingColors(val);
      },
      deep: true
    },

  },


  async onIdle() {
    if ( this.kioskMode ) {
   
      // Clear cart item if any
      if(this.vg_cartId && this.vg_cartItems.length > 0){
        // if any item added on cart clear it 
        await CartApis.clearcart(this.vg_cartId)
          .then(res => res)
          .catch(err => err);
      }

      // logout user if loggedin 
      await this.signOutIfLoggedIn()

      // move to landing page, if its not store profile page
      if(this.$route.name != 'StoreLanding'){
        this.$router.push({ 
          name: 'StoreLanding', 
          params: { business_slug: this.$route.params.business_slug,  store_slug: this.vg_selectedStore.slug },
          query: this.$route.query, 
        })
      } 
    }
  },

  methods:{   
    /**
     * Check business and business loyalty and subscribe or remove
     */
    checkBusinessLoyaltyAndMakeAction() {
      if(this.vg_businessProfile.id && this.vg_loggedInUser && this.vg_loggedInUser.id && this.vg_businessLoyality.id && this.vg_businessLoyality.is_active){
        this.checkUserBusinessLoyaltySubscription({ user_id: this.vg_loggedInUser.id });
      } 
  
      if((this.vg_businessLoyality.is_active == undefined) || (this.vg_businessLoyality.is_active == false) ){
        this.va_setUserLoyalityObj({});
      } 
      if(this.vg_loggedInUser.id && this.vg_businessProfile.id && this.vg_businessLoyality.is_active) {
        this.va_setUserLoyalityObj({
          user_id: this.vg_loggedInUser.id, 
          business_id: this.vg_businessProfile.id
        });
      }
    },


    /**
     * Hex to rgb
     */
    hexToRgb(hex) {
      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    },
    /**
     * logout user + send them to shop page
     */
    async signOutIfLoggedIn() {
      // If user logged in clear him
      if(this.$store.getters.getLoggedInUserId){
        
        // Clear user loyalty
        this.va_setUserLoyalityObj({});
        // Unsubscribe channels
        Helpers.pubnubUnSubscribeAllChannels({
          user_id: this.$store.getters.getLoggedInUserId,
          location_id: this.vg_selectedStore.id,
        });

        // remove local data either lout out fail or true
        await UserApis.logout();
        // remove Fb cache if any
        if(window.FB != undefined){
          window.FB.getLoginStatus((fbloginRes) =>{
            if(fbloginRes.status == 'connected'){
              window.FB.logout(function(){
                console.log('fb out.')
              });
            }
          })
        }
      }

      // Now we dont need to send on home page rather send to location page
      this.va_clearCart();
      this.$store.dispatch('REMOVE_APP_DATA', '');
    },


    /**
     * Set branding colors
     */
    setBrandingColors(val) {
      // document.title = val.name;
      // document.getElementById("icon").href = val.branding.logo_url; dont need business fav icon for now
      let bodyStyles = document.body.style;
      if(val.branding && val.branding.primary_color){
    
        bodyStyles.setProperty('--primary-color',val.branding.primary_color);
        
        let primaryExp = val.branding.primary_color.split(',');
        primaryExp.pop();
        primaryExp.push('0.1)');  // 10percent opacity
        let primaryLight = primaryExp.join(',');
        bodyStyles.setProperty('--primary-color-light', primaryLight);
      }
      if(val.branding && val.branding.secondary_color){
        // defined is what we got 
        bodyStyles.setProperty('--secondary-defined', val.branding.secondary_color);
        // full we have to make 100% of it 
        let secExp = val.branding.secondary_color.split(',');
        secExp.pop();
        secExp.push('1)');
        let secFullvalue = secExp.join(',');
        bodyStyles.setProperty('--secondary-full', secFullvalue);

        let secLight = val.branding.secondary_color.split(',');
        secLight.pop();
        secLight.push('0.1)');
        let secLightValue = secLight.join(',');
        bodyStyles.setProperty('--secondary-light', secLightValue);
      }
      if(val.branding && val.branding.accent_color){
        bodyStyles.setProperty('--accent-color', val.branding.accent_color);
      }
      // if(val.branding && val.branding.font && val.branding.font.color){
      //   bodyStyles.setProperty('--font-color', val.branding.font.color);
      //   let fontColorLight;
      //   // values come on hex assisn color == light color
      //   if(val.branding.font.color.indexOf(',') > -1){
      //     let secExp = val.branding.font.color.split(',');
      //     secExp.pop();
      //     secExp.push('0.7)');
      //     fontColorLight = secExp.join(',');
      //   } else {
      //     fontColorLight = val.branding.font.color;
      //   }
      //   bodyStyles.setProperty('--font-color-light', fontColorLight);
      // }
      // if(val.branding && val.branding.font && val.branding.font.family){
      //     bodyStyles.setProperty('--font-family', val.branding.font.family);
      // } 
      if(val.branding && val.branding.font && val.branding.font.url){
        // if url doesnot have otf or ttf then load from url 
        let fullurlExp = val.branding.font.url.split('.');
        let urlLastVal = fullurlExp.pop();
        if(urlLastVal == 'otf' || urlLastVal == 'ttf' || urlLastVal == 'woff'){
          this.loadInlineCss(val.branding.font)
        } else{ 
          this.loadCss(val.branding.font.url)
        }
      }
      // Box shadow
      if(val.branding && val.branding.meta && val.branding.meta.border_color){
        bodyStyles.setProperty('--box-shadow', val.branding.meta.border_color);
      }
    },
    /**
     * Trigger pubnub channel
     */
    async triggerPubNobChannel({ subscribeChannel }) {
      const self = this;
       window.pubnubListners = {
        status: function() {
          console.log('pubnub connected...')
        },
        message: async function(data) {
          
        //  console.log(data);
          
          if(!self.$store.getters.getLoggedInUserId){
            return;
          }
          //console.log(data)
          // Catch pubnub message
          // Do not catch message, for edit profile on checkout page
          if( (data.message.declaration == 'update_profile') && (self.$route.name == 'Checkout')){
            // Silent on this emit
          } else {
            self.va_snackbar({
              type: 'success', 
              message: data.message.title,
            });
          }
        
          if(data.message.declaration == 'update_profile'){
            self.vm_mutateUserDetailByKeys({
              first_name: data.message.payload.first_name,
              last_name: data.message.payload.last_name,
              email: data.message.payload.email,
              phone: data.message.payload.phone,
              marketing_notification: data.message.payload.marketing_notification,
              email_notification: data.message.payload.email_notification,
            })
          } else if (data.message.declaration == 'favorite_list'){
            // Fetch user fav list, previously return data now ids
            await UserApis.fetchFavProducts();
          } else if( data.message.declaration == 'user_cart') {
            
            self.va_setCartDetail(data.message.payload);
            self.va_setCartItems(data.message.payload.cart_items);
            //self.setCartLoyalty();
            // after 1 sec hide spinner
            setTimeout(() => {
              self.va_spinner(false);
            }, 1000)
     
          } else if( data.message.declaration == 'cart_processed') {
            bus.$emit('open-sidebar-cart', false); 
            self.va_setCartId('');
            self.va_setCartDetail({});
            self.va_setCartItems([]);
           // self.va_setCartLoyalityPointsObj();
     
          } else if (data.message.declaration == 'order_notification'){
            self.va_updateOrderStatus(data.message.payload);
            // if the order status is completed then we need to move it to past order if we are on current active tab
            // step 1 fetch again the orders 
            // step on success set the tab to pas order 
            if(!_.isEmpty(self.vg_currentOrder)){
               if((data.message.payload.status == 'completed' || data.message.payload.status == 'cancelled') && self.vg_currentOrder.id == data.message.payload.id){
                bus.$emit('update-order-status-refetch', data.message.payload);
              }
            }
        
            // if we are on cart success then if status is immediate changed, update cart success
            if(self.vg_cartSuccessObj.id == data.message.payload.id){
              self.va_setSuccessObj(data.message.payload);
            }

          } 
        },
        presence: function() {
          
        }
      };
      
      // Stop if there logged in user
      if(!this.$store.getters.getLoggedInUserId ){ 
        window.pubnub.removeListener(pubnubListners);
        window.pubnub.unsubscribeAll();
      } else {
        if(subscribeChannel){
           Helpers.pubnubSubscribeAllChannels({ 
            user_id: this.$store.getters.getLoggedInUserId, 
            location_id: this.vg_selectedStore.id
          }); 
        } else if( this.routeWithReSyncLocations.includes(this.$route.name) == false ) {
           // For those pages channel will be subscribe on that page on mount
          Helpers.pubnubSubscribeAllChannels({ 
            user_id: this.$store.getters.getLoggedInUserId, 
            location_id: this.vg_selectedStore.id
          }); 
        }
        window.pubnub.addListener(window.pubnubListners);
      }
    },

    /**
     * Load inline css
     */
    loadInlineCss(font) {
      let ffexist =  document.getElementById('ff-script');
      if (typeof(ffexist) != 'undefined' && ffexist != null){
        // script already exists
        return false;
      }
       new Promise( function( resolve, reject ) {
        let css =`
        @font-face {
          font-family: ${font.family},
          src: url("${font.url}") format("${font.type ? '' : 'opentype'}");
        }`,
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style');
        head.appendChild(style);
        style.id = 'ff-script';
        style.type = 'text/css';
        if (style.styleSheet){
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
        style.onload = function() { 
          resolve(); 
        };
      } );
    },

    /**
     * Load css
     */
    loadCss( cssURL ) {
      // get all stylesheet and check if we have already loaded this css
      var ss = document.styleSheets;
      for (var i = 0, max = ss.length; i < max; i++) {
          if (ss[i].href == cssURL)
          return;
      }
      return new Promise( function( resolve, reject ) {
        let link = document.createElement( 'link' );
        link.rel  = 'stylesheet';
        link.href = cssURL;
        document.head.appendChild( link );
        link.onload = function() { 
          resolve(); 
        };
      } );
    },

    /**
     * Signout user
     */
    async signOut() {

      // Clear user loyalty 
      this.va_setUserLoyalityObj({});
      // Unsubscribe channels
      Helpers.pubnubUnSubscribeAllChannels({
        user_id: this.$store.getters.getLoggedInUserId,
        location_id: this.vg_selectedStore.id,
      });

      // Remove local data either lout out fail or true
      await UserApis.logout();
      this.va_snackbar({
        type: 'success',
        message: 'Session expired.. Please login again..',
      });
      // If no success also clear localstorage data and restart
      this.va_clearCart();
      this.$store.dispatch('REMOVE_APP_DATA', '');
      this.$router.push({ 
        name: 'HomePage', 
        param: { business_slug: this.$route.params.business_slug }
      });
    },

    /**
     * on success login set datas
     */
    async setLoginSuccessUserData(res) {
      const self = this;
      // If empty fetch business becasue business might not have fetched
      if(_.isEmpty(this.vg_businessProfile) || !this.vg_businessProfile.id) {
        // To add data on Vbout lets on rely on business / locaiton vuex because we are resetting data to prevent flickering
        await BusinerssProfileApis.fetchBusinessProfile(this.$route.params.business_slug);
      }
      // after business fetch then only
     
      let locationDetailRes = await LocationApis.fetchBySlug(this.$route.params.store_slug, true);
 
      this.$store.dispatch("SET_USER_TOKEN", res.data.payload.token);
      this.$store.dispatch("SET_USER_DETAILS", res.data.payload);
      this.$store.dispatch("SET_USER_LOGGEDIN_DATE", moment().format('YYYY-MM-DD HH:mm:ss'));
      if(res.data.payload.id && this.vg_loggedInUser.id && this.vg_businessLoyality.id && this.vg_businessLoyality.is_active){
        this.checkUserBusinessLoyaltySubscription({ user_id: res.data.payload.id });
      }

      if(locationDetailRes.status == 200){
        // Push user to vbout
        await VboutApis.upsertUser(res.data.payload, locationDetailRes.data.payload.id);
        // if user has email_verification_status = true tag it 
        if(res.data.payload.email_verification_status){
          await VboutApis.addUserTag({
            email: res.data.payload.email,
            tagname: 'verified',
          }, locationDetailRes.data.payload.id);
        }
        // casl_opt_in as marketing notification
        if(res.data.payload.marketing_notification){
          await VboutApis.addUserTag({
            email: res.data.payload.email,
            tagname: 'casl_opt_in',
          }, locationDetailRes.data.payload.id);
        }
      }

      // fetch order, new user ownt have order
      // let orderHistory =  await OrderHistoryApis.fetch(1);
      // fetch user fav location
     // UserApis.fetchFavLocations();
      // fetch user fav products
     // UserApis.fetchFavProducts();

      // as soon as user logged in remove guest checkout params
     // this.va_setGuestLandedQueries({})
      // if we have selected store fetch that store cart items 
      if(!_.isEmpty(this.vg_selectedStore) && this.vg_selectedStore.id != ''){
        
        if(this.vg_cartItems.length == 0){
          // Fetch cart is guest doesnot have any cart
          await CartApis.locationCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));
        } else {
          // Fetch and merge guest and user cart
          await CartApis.convertGuestCartToUserCart(Helpers.getLocationCartFullUrl(this));
        }

       // this.setCartLoyalty()
       // await this.va_setCartLoyalityPointsObj();
        // After login push cart item on vbout but before that clear cart
        // First clear vbout cart
        // user just verified no need to clear cart
        // await VboutApis.emptyCart(this.vg_cartId, this.vg_selectedStore.id);
        // Add product one by one
        if(this.vg_cartItems && this.vg_cartItems.length > 0){
          this.vg_cartItems.forEach(async (item) => {
            await VboutApis.addCartItem(item, Helpers.getLocationProductFullUrl(self, item.product_id), self.vg_selectedStore.id);
          })
        }
      }

      // lets see if we have any pending item for cart
      // if yes 
      if(!_.isEmpty(this.vg_pendingItemOnCart)) {
        // we have pending item
        await bus.$emit('listen-pending-cart-item', this.vg_pendingItemOnCart);
        // once emit make it balnk
        this.va_setPendingItem({});
      }
      // if(orderHistory.status == 200) {
      //   this.va_setAllOrders(orderHistory.data.payload);
      // }
      // add user location on login
      if(this.vg_selectedStore.id){
        UserApis.addUserLocation(res.data.payload.id, this.vg_selectedStore.id, this.$route.query);
      }
      return '';
    },
    
    /**
     * We are using with debounce, getting multiple emits, to prevent that we use this
     */
    setCartLoyalty: _.debounce(function(){
      console.log('preview debounced')
      // this.va_setCartLoyalityPointsObj();
    }, 800),

    /**
     * Check loyalty subscription if subscribed alredt congraluations 
     */
    async checkUserBusinessLoyaltySubscription({ user_id }) {
       // ON email verification alert user with loyalty bouns
      let loyaltyJoinRes = await this.va_joinUserOnLoyalityProgram({
        user_id: user_id,
        business_id: this.vg_businessProfile.id,
        referral_key: this.$route.query.referral_key ? this.$route.query.referral_key : '', // if has ref key pass it 
      })
      
       // show loyalty bonus point for signup
      if( (loyaltyJoinRes.status == 201) && (loyaltyJoinRes.data.payload.welcome_bonus > 0) ) {
        bus.$emit('loyality-signup-congratulations', {
          modal: true,
          point: loyaltyJoinRes.data.payload.welcome_bonus,
          message: "Sign Up Bonus!",
        })
      }

      // Show loyalty referral point
      if( (loyaltyJoinRes.status == 201) && (loyaltyJoinRes.data.payload.referral_bonus > 0) ) {
        bus.$emit('loyality-referral-congratulations', {
          modal: true,
          point: loyaltyJoinRes.data.payload.referral_bonus,
          message: "A little something for being referred!",
        })
      }

    },
 
    ...mapMutations({
      vm_mutateUserDetailByKeys: "MUTATE_USER_DETAILS_BY_KEYS",
      vm_pubnubInitTimeTokenMutate: 'app_pubnub/pubnubInitTimeTokenMutate',
      vm_mutateInStore: 'MUTATE_IN_STORE',
      vm_mutatePageLoadUrl: 'MUTATE_PAGE_LOAD_URL',
    }),

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_setCartItems: "cart/setCartItems",
      va_setCartDetail: "cart/setCartDetail",
      va_setCartId: "cart/setId",
     // va_setFavProducts: "favouriteproducts/setList",
      va_setEmptySearchFilter: "searchproduct/setEmptySearchFilter",
      va_snackbar: "snackbar/setSnackbar",
      va_updateOrderStatus: "orderhistory/updateOrderStatus",
      va_setSuccessObj: 'cart/setSuccessObj',
      va_clearCart: "cart/clearCart",
      va_resetBusinessProfileDetail: "businessprofile/resetDetail",
      va_setEmailVerified: "emailverification/setVerified",
      va_setGuestLandedQueries: "location/setGuestLandedQueries",
      va_setPendingItem: "cart/setPendingItem",
      va_setAllOrders: "orderhistory/setAllOrders",
      vg_setPasswordObj: "setpassword/setObj",
      va_setCartLoyalityPointsObj: "cart/setLoyalityPointsObj",
      va_setSelectedLocation: "location/setSelected",
      va_setUserLoyalityObj: "userloyalitysubscription/setUserLoyalityObj",
      va_joinUserOnLoyalityProgram: "userloyalitysubscription/joinUserOnLoyalityProgram",
      va_setSignupModal: "signupmodal/setModal",
      va_setPastSelectedLocationId: "location/setPastSelectedLocationId",
    })
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,300;1,500&display=swap');
:root{
  --primary-color: #8cc63d;
  --primary-color-light: #fdfdfd;
  --secondary-defined: #434343;
  --secondary-full: #363636;
  --secondary-light: #434343;
  --accent-color: #8c8c8c;
  --font-color: #111010;
  --font-color-light: #CCCCC;
  --font-family: 'Roboto', sans-serif;;
  --box-shadow: rgba(0, 0, 0, 0.05);
}
.bg-accent{
  background-color:  var(--accent-color) !important; 
}
.bg-secondary{
  background-color:  var(--secondary-full) !important; 
}
.bg-primary{
  background-color:  var(--primary-color) !important; 
}
.bg-primary-light{
  background-color:  var(--primary-color-light) !important; 
}
.bg-secondary-full{
  background-color: var(--secondary-full) !important; 
}
.bg-secondary-defined{
  background-color: var(--secondary-defined) !important; 
}
.bg-secondary-light{
  background-color: var(--secondary-light) !important; 
}
.hover-bg-secondary:hover{
    background-color: var(--secondary-full) !important; 
}
.has-secondary-border{
  border-color: var(--secondary-full);
}
.hover-bg-accent:hover{
    background-color: var(--accent-color) !important; 
}
.hover-bg-primary:hover{
    background-color: var(--primary-color) !important; 
}
.hover-bg-primary-color-light:hover{
    background-color: var(--primary-color-light) !important; 
}
.is-primary-outline{
  border:1px solid var(--primary-color); 
  color: var(--primary-color); 
  background: none;
}
.is-primary-outline:hover{
  border:1px solid var(--primary-color); 
  background-color:  var(--primary-color); 
  color: #fff;;  
}
.is-secondary-outline{
  border:1px solid var(--secondary-full); 
  color: var(--secondary-full); 
  background: none;
}
.is-secondary-outline:hover{
  border:1px solid var(--secondary-full); 
  background-color:  var(--secondary-full); 
  color: #fff;;  
}
.category-list .category-item.is-active span::after{
  display: none;
}
.category-item:hover a,
.category-item.is-active a{
  background: var(--primary-color-light) !important; 
}
p,h1,h2,h3,h4,h5,h5,li,a,span,div,li,button,select,input {
  font-family: var(--font-family) !important; 
}
::-webkit-input-placeholder { /* Chrome/Opera/Safari */
   font-family: var(--font-family) !important; 
}
::-moz-placeholder { /* Firefox 19+ */
   font-family: var(--font-family) !important; 
}
:-ms-input-placeholder { /* IE 10+ */
   font-family: var(--font-family) !important; 
}
:-moz-placeholder { /* Firefox 18- */
   font-family: var(--font-family) !important; 
}
p,h1,h2,h3,h4,h5,h5,li,a,
.product-category-block h3, 
.store-nearby-heading, 
.location-block h3, 
.selected-store-info .store-name, 
.category-list .category-item a:hover, 
.category-list .category-item.is-active span, 
.pg-title-block .title, .product-name, 
.product .product-details .product-desc, 
.title-block a .fav-btn, 
.button.nav-back .fas, 
.accordions .accordion .accordion-header, 
.product-consumption-block .consumption-note, 
.footer .footer-quick-links ul li a, 
.footer .footer-quick-links h3, 
.copyright-section p, 
.intro-block h2, 
.intro-block p, 
.store-title, .store-name p, 
.title, .variant-unit-price span, 
.product-feature span, 
.button.is-transparent.btn-complete span, 
.tax-price, 
.tax-price span, 
.tax-price .has-text-black, 
.subtotal-box p, 
.text-white, 
.product-tile.cart-item .product-tile__name, 
/* .product-tile.cart-item .product-tile.cart-item .product-tile__brand .starting-price, 
.product-tile.cart-item .product-tile__brand .starting-price,  */
.product-tile.cart-item .product-tile__brand span, .product-tile.cart-item .product-tile__brand .item-weight,
 .location-info .store-locality, .location-info .address, .location-info .store-status, 
 .fav-tabs .tabs li.is-active a, .intro-section .intro-block p, .location-block .location-address .address, 
 .location-block .location-distance, .order-history-sidebar.tabs li a, .history-switch-tab li.is-active a, 
 .history-switch-tab li a:hover, .store-profile .selected-store-info .store-address, 
 .order-pickup-block .pickup-time .hour, .order-pickup-block .pickup-time .am-pm, 
 .order-pickup-block .dash, 
 .timeline .timeline-item .timeline-content .heading, 
 .product-black-block .product-tile__name, 
 .product-black-block .product-tile__availability, .product-black-block .product-tile__brand .brand-name, 
 .product-black-block .product-tile__footer span, .edit-account .control.is-animate .placeholder, 
 .edit-account .control.is-animate .input, .edit-account .control select, .edit-account .edit-account-dob p, .btn-green:hover, 
 .is-required, .privacy-policy, .privacy-policy p, .privacy-policy strong, .privacy-policy a, 
 .timeline .timeline-item .timeline-content .heading+p, .timeline .timeline-item.is-active:first-child .timeline-content .heading, 
 .store-details-wrapper .product-attr .variant-block .variant-unit-price,
.toggle .fa-sort-up, .toggle .fa-sort-down,
.category-list .category-item a,
.category-list .category-item.is-active span,
div,
.button.is-white, 
.location-search-bar .button,
span,
section.body-searchbar.show input,
.mobile-filter-menu,
.font-color,
a.clear-filter:hover,
a.clear-filter,
/* .sidebar-cart-item .quantity-block .button,
.sidebar-cart-item .quantity-block .button.minus, */
.button.font-color.btn-skip{
  color: var(--font-color); 
}
.bg-white-imp .footer .footer-quick-links h3,
.bg-white-imp  .footer   p,
.bg-white-imp  .footer  strong {
  color: var(--font-color) !important; 
}

.text-primary{
  color: var(--primary-color);  
}
.hover-text-primary:hover{
  color: var(--primary-color) !important;  
}
.text-secondary{
  color: var(--secondary-full);  
}
.hover-text-secondary:hover{
  color: var(--secondary-full) !important;  
}
.hover-text-accent:hover{
  color: var(--accent-color) !important;  
}
.shop-link g,
.variant-display-handler svg path{
   fill: var(--secondary-full); 
}
/* .shop-link:hover,
.shop-link:hover g{
   color: var(--accent-color) !important; 
   fill: var(--accent-color) !important; 
} */
.is-primary-outline.cart-add-more{
  border-color: var(--font-color); 
}
.is-primary-outline.cart-add-more:hover{
  color: #FFF;
  background: var(--secondary-full);  
  border-color: var(--secondary-full);
}

.store-profile-search .variant-block .is-checkradio[type="checkbox"]+label.with-border .variant-price,
.store-profile-search .variant-block .variant-price,
.store-profile-search .search-brands .variant-item-block .variant-price,
.store-profile-search .product-sorting .variant-item-block .variant-price{
   color: var(--font-color); 
}
.store-profile-search .variant-block .is-checkradio[type="checkbox"]+label.with-border,
.new-mobile-filter-wrap .variant-block .is-checkradio[type="checkbox"]+label.with-border,
.searchproductresult-page-main .control-section--filter.product-form .label-wrap,
.mobile-filters-wrap .variant-block .is-checkradio[type="radio"]+label, 
.mobile-filters-wrap .variant-block .is-checkradio[type="checkbox"]+label,
.mobile-filters-wrap .search-brands .is-checkradio[type=checkbox]:hover:not([disabled])+label:before,
.mobile-filters-wrap .search-brands .is-checkradio[type=checkbox],
.mobile-filters-wrap .search-brands .is-checkradio[type="checkbox"]+label:before,
.searchproductresult-page-main .search-brands .is-checkradio[type="checkbox"].is-block+label:before {
  border: 2px solid var(--primary-color-light);
}


/**
this has background secondsry define so useless
*/
.store-details-wrapper .sizes-section .variant-block .is-checkradio[type="radio"]+label, 
.store-details-wrapper .sizes-section .variant-block .is-checkradio[type="checkbox"]+label{
  border: 2px solid var(--primary-color-light);
}

.store-profile-search  .is-checkradio[type=checkbox]+label:before, 
.store-profile-search  .is-checkradio[type=radio]+label:before{
  border: 2px solid var(--primary-color-light);
}
.store-profile-search .is-checkradio[type="radio"]:checked+label::before, 
.new-mobile-filter-wrap .is-checkradio[type="radio"]:checked+label:before,
.new-mobile-filter-wrap .is-checkradio[type="radio"]:hover:not([disabled])+label::before,
.mobile-filters-wrap .variant-block .is-checkradio[type="radio"]:checked+label, 
.mobile-filters-wrap .search-brands .is-checkradio[type=checkbox]:checked +label::before {
 border: 2px solid var(--primary-color) !important; 
}
/* section.control-section--filter.product-types .variant-block .is-checkradio[type="checkbox"]:checked+label .variant-price,
.store-profile-search .variant-block .is-checkradio[type="checkbox"]:checked+label.with-border .variant-price{
  color: var(--secondary-defined);  
} */
.store-profile-search .is-checkradio[type="radio"]:hover:not([disabled])+label::before,
.store-profile-search .is-checkradio[type="radio"]:hover:not([disabled])+label:before,
.store-profile-search .is-checkradio[type="checkbox"]:hover:not([disabled])+label::before,
.store-profile-search .is-checkradio[type="checkbox"]:hover:not([disabled])+label:before,
.searchproductresult-page-main .search-brands .is-checkradio[type="checkbox"]:hover:not([disabled])+label::before,
.searchproductresult-page-main .search-brands .is-checkradio[type="checkbox"]:hover:not([disabled])+label:before {
    border-color: var(--primary-color) !important; 
}

.searchproductresult-page-main .control-section--filter.product-form .label-wrap:hover,
.searchproductresult-page-main .variant-block .is-checkradio[type="checkbox"]:checked+label {
    border-color: var(--primary-color); 
    background-color: var(--primary-color-light);
}
.store-profile-search  .filter-radio-group.child-50 .variant-block-new-style .is-checkradio[type="checkbox"]:checked+label:before,
.store-profile-search .search-brands .variant-block-new-style .is-checkradio[type="checkbox"]:checked+label:before,
.searchproductresult-page-main .search-brands .variant-block-new-style .is-checkradio[type="checkbox"]:checked+label:before,
.new-mobile-filter-wrap .search-brands .variant-block-new-style .is-checkradio[type="checkbox"]:checked+label:before{
  border: 2px solid var(--primary-color) !important;
  color: var(--primary-color) !important;
}
.store-profile-search .variant-block .is-checkradio[type="checkbox"]+label.with-border:hover,
.variant-block .is-checkradio[type="checkbox"]:checked+label.with-border,
section.control-section--filter.product-types .variant-block .is-checkradio[type="checkbox"]:checked+label,
section.control-section--filter.product-types .variant-block .is-checkradio[type="checkbox"]:checked+label:hover,
.store-profile-search .variant-block .is-checkradio[type="checkbox"]+label:hover,
.clear-filter:hover{
  background: var(--primary-color-light);
  color: var(--primary-color) !important;
  border: 2px solid var(--primary-color);
}
section.control-section--filter .variant-block .is-checkradio[type="checkbox"]+label div,
.store-profile-search .variant-block .is-checkradio[type="checkbox"]+label div{
  color: #333 !important;
}

section.control-section--filter.product-types .variant-block .is-checkradio[type="checkbox"]:checked+label div,
.store-profile-search .variant-block .is-checkradio[type="checkbox"]+label:hover div,
.store-profile-search .variant-block .is-checkradio[type="checkbox"]+label.with-border:hover div,
.searchproductresult-page-main .variant-block .is-checkradio[type="checkbox"]:checked+label div,
.searchproductresult-page-main .variant-block .is-checkradio[type="checkbox"]:hover+label div{
  color: var(--primary-color) !important;
}
.store-profile-search .filter-radio-group.child-50 .variant-block-new-style .is-checkradio[type="checkbox"]+label::after, 
.store-profile-search .filter-radio-group.child-50 .variant-block-new-style .is-checkradio[type="checkbox"]+label:after, 
.store-profile-search .search-brands .variant-block-new-style .is-checkradio[type="checkbox"]+label:after, 
.store-profile-search .product-sorting .variant-block-new-style .is-checkradio[type="radio"]:checked+label:after,
.new-mobile-filter-wrap .search-brands .variant-block-new-style .is-checkradio[type="checkbox"]+label:after,
.store-profile-search .filter-radio-group.child-50 .variant-block-new-style .is-checkradio[type="checkbox"]+label::after, .store-profile-search .filter-radio-group.child-50 .variant-block-new-style .is-checkradio[type="checkbox"]+label:after, .store-profile-search .search-brands .variant-block-new-style .is-checkradio[type="checkbox"]+label:after, 
.store-profile-search .product-sorting .variant-block-new-style .is-checkradio[type="radio"]:checked+label:after {
  border-color: var(--primary-color);
}


.filter-headers div a:hover, 
.filter-headers div a.active, 
.sm-category-list li a.active, 
.sm-category-list li a:hover,
.footer .footer-quick-links ul li a:hover  {
  color: var(--primary-color);
}
.filter-headers div a.active, .sm-category-list li a.active {
    border-bottom: 2px solid var(--primary-color);
}
.category-list .category-item a,
.product .product-details .company-name,
.product-features-block .feature-text,
.order-summary-block .location-address .address,
.fav-tabs .tabs li a,
.history-switch-tab li a,
.privacy-policy a:hover,
.has-text-info,
.location-block p,
.intro-section .intro-block p,
.has-text-grey,
.has-text-grey p{
   color: var(--font-color-light); 
}
.change-pass-text,
.store-profile ::-webkit-input-placeholder,
.store-profile :-ms-input-placeholder,
.store-profile ::placeholder{
   color: var(--font-color) !important; 
}

/* .store-details-wrapper, 
.store-details-wrapper .store-details-block,  */
/* .order-summary-block,  */
/* .product-tile.cart-item,  */
/* .footer, 
.order-status-right, 
.product-black-block,  */
.product-black-block .product-tile__footer,
.button.search-btn{
  background: var(--secondary-full) !important; 
}
a.clear-filter{
  border: 2px solid var(--secondary-full); 
}
/* .product-black-block .product-tile__footer{
  border-top: 2px solid var(--secondary-full) !important; 
} */

section.body-searchbar.show,
section.body-searchbar.show input,
.button-accent{
  background: var(--accent-color) !important; 
}
.button-accent{
  border-color: var(--accent-color) !important; 
}
.store-details-wrapper .store-details-bottom .button.add-to-cart-btn, 
.order-summary-block .btn-complete, 
.button.is-transparent.btn-complete, 
.product-tile__brand .starting-price, 
.product-tile.cart-item .product-tile__brand .starting-price, 
.btn-green, 
.notification.is-primary,
.button.is-primary,
.button-accent:hover{
  background: var(--primary-color) !important; 
  border-color: var(--primary-color) !important; 
  color: #FFF;
}
.open-filter-modal{
  background: var(--secondary-full) !important; 
  border-color: var(--secondary-full) !important; 
  color: #FFF;
}
.is-checkradio[type="radio"]+label::after, .is-checkradio[type="radio"]+label:after{
    background: var(--primary-color) !important; 
}
.subtotal-box .is-checkradio[type="radio"]:checked+label::before, 
.subtotal-box .is-checkradio[type="radio"]:checked+label:before, 
.subtotal-box .is-checkradio[type="checkbox"]:checked+label::before, 
.subtotal-box .is-checkradio[type="checkbox"]:checked+label:before{
  border: 0.1rem solid var(--primary-color) ; 
}
.sub-total-line {
    height: 1px;
    background: var(--font-color);
    margin: 3px 15px;
}
/* .product-detail-wrapper .variant-block .is-checkradio[type="radio"].is-block:hover+label{
   border: 3px solid var(--primary-color);
   background: #949494;
} */
.intro-section{
  border-bottom: inset 3px var(--primary-color) !important; 
}
.is-checkradio[type="checkbox"]+label::after, .is-checkradio[type="checkbox"]+label:after{
    border-color: var(--primary-color) !important; 
}
.button.is-primary:hover{
  opacity: 0.7;
  /* background: var(--primary-color-light) !important; 
  border-color: var(--primary-color-light) !important;  */
}

/* .pg-wrapper, 
section.selected-store-info, 
.store-locations-sidebar, 
.has-background-white-bis{
  background: var(--secondary-defined) !important; 
} */
.product-features-block{
  border-top: 1px solid var(--primary-color);
}
.product-features-block,
.product-profile-block{
  border-bottom: 1px solid var(--primary-color);
}
.product-tile{
  -webkit-box-shadow: 0 5px 10px 0  var(--box-shadow) !important; 
  box-shadow: 0 5px 10px 0 var(--box-shadow) !important; 
}

/**:
  usage: var(--accent-color); 
*/
.has-text-black{
  color:#000000 !important;
}

/**
* overide modal text to dark black by default
*/
.edit-account .control select {
    background: inherit !important;
}
.site-wrapper .modal p,
.site-wrapper .modal h1,
.site-wrapper .modal h2,
.site-wrapper .modal h3,
.site-wrapper .modal h4,
.site-wrapper .modal h5,
.site-wrapper .modal h6,
.site-wrapper .modal li,
.site-wrapper .modal span,
.site-wrapper .modal input,
.site-wrapper .modal select,
.site-wrapper .modal label,
.pac-item,
.pac-container .pac-item,
.pac-container .pac-item span,
.order-details p,
.order-details td,
.order-details span,
.order-details div,
.order-location p,
.order-location div,
.order-location span,
.order-status .pg-title-block .title,
.order-history-wrapper .title-bar .title{
    color:#212121 !important;
}
.pac-container .pac-item .pac-matched{
  color: #37b544 !important;
}

.order-details .has-text-green{
  color: #37b544 !important;
}
.site-wrapper .is-checkradio[type="radio"]:hover:not([disabled])+label::before, 
.site-wrapper .is-checkradio[type="radio"]:hover:not([disabled])+label:before, 
.site-wrapper .is-checkradio[type="checkbox"]:hover:not([disabled])+label::before, 
.site-wrapper .is-checkradio[type="checkbox"]:hover:not([disabled])+label:before,
.site-wrapper .is-checkradio[type="radio"]+label::before, 
.site-wrapper .is-checkradio[type="radio"]+label:before, 
.site-wrapper .is-checkradio[type="checkbox"]+label::before, 
.site-wrapper .is-checkradio[type="checkbox"]+label:before{
  color:#212121 !important;
}
.site-wrapper .cart-wrapper .is-checkradio[type="radio"]:hover:not([disabled])+label::before, 
.site-wrapper .cart-wrapper .is-checkradio[type="radio"]:hover:not([disabled])+label:before,
.site-wrapper .cart-wrapper .is-checkradio[type="checkbox"]:hover:not([disabled])+label::before, 
.site-wrapper .cart-wrapper .is-checkradio[type="checkbox"]:hover:not([disabled])+label:before,
.site-wrapper .cart-wrapper .is-checkradio[type="radio"]+label::before, 
.site-wrapper .cart-wrapper .is-checkradio[type="radio"]+label:before, 
.site-wrapper .cart-wrapper .is-checkradio[type="checkbox"]+label::before,
.site-wrapper .cart-wrapper .is-checkradio[type="checkbox"]+label:before,
.site-wrapper .checkout-wrapper .is-checkradio[type="radio"]+label:before
{
  border-color:  var(--primary-color) !important;
}
/* .store-profile-search .modal-card-head, 
.store-profile-search .modal-card-foot,
.store-profile-search .modal-card-body{
  background: var(--accent-color);
} */

.store-profile-search p,
.store-profile-search li,
.store-profile-search span,
.store-profile-search label{
  color:  var(--font-color);
}
/* .store-profile-search .variant-block .is-checkradio[type="radio"]+label, 
.store-profile-search .variant-block .is-checkradio[type="checkbox"]+label{
  background: var(--secondary-defined); 
} */

main .bg-white-imp a:hover{
  color:var(--primary-color) !important;
}
.landing-product-item {
  background-color: var(--secondary-defined) !important; 
}
.landing-product-item:hover{
  box-shadow: 0 3px 10px -4px var(--primary-color);
  transition: all 0.4s ease-in-out;
}
 .sizes-section .variant-block .is-checkradio[type="radio"]+label:hover{
  border-color:  var(--primary-color) ;
}
.sizes-section .has-sale .variant-block .is-checkradio[type="radio"]+label:hover{
  border-bottom-color: rgb(148 148 148 / 0%) !important;
}
.store-details-wrapper .sizes-section .variant-block .is-checkradio[type="radio"]+label:hover{
  border: 2px solid var(--primary-color) !important;
}

/* .mobile-filters-wrap .search-brands .is-checkradio[type=checkbox]:hover:not([disabled])+label:before,
.mobile-filters-wrap .search-brands .is-checkradio[type=checkbox],
.mobile-filters-wrap .search-brands .is-checkradio[type="checkbox"]+label:before{
  border: 1px solid var(--secondary-defined);
  border-color: var(--secondary-defined);
} */
.sizes-section .variant-block .is-checkradio[type="radio"]+label:hover .variant-weight,
.sizes-section .variant-block .is-checkradio[type="radio"]+label:hover .variant-price{
  color: var(--primary-color);
}
.sizes-section .variant-block .is-checkradio[type="radio"]+label:hover .variant-unit-price span{
   color: var(--primary-color) !important;
}
/* .sizes-section .variant-block .is-checkradio[type="radio"]+label:hover .variant-weight{
  border-bottom: 1px solid var(--primary-color);
} */
/* .store-details-block .quantity-block .button.minus,
.store-details-block .quantity-block .button.plus,
.cart-item .quantity-block .button.minus,
.cart-item .quantity-block .button.plus{
    color: var(--font-color); 
} */

.variant-block .is-checkradio[type="radio"]:checked+label .variant-price.has-text-black, 
.variant-block .is-checkradio[type="checkbox"]:checked+label .variant-price.has-text-black{
   color: var(--font-color)  !important; 
}

.location-addto-cart-modal .quantity-block .button.minus,
.location-addto-cart-modal .quantity-block .button.plus,
.store-details-block .quantity-block .button.minus,
.store-details-block .quantity-block .button.plus,
.cart-item .quantity-block .button.minus,
.cart-item .quantity-block .button.plus{
  background-color: var(--primary-color);
  color: #FFF;
}
.location-addto-cart-modal .quantity-block .button.minus:hover,
.location-addto-cart-modal .quantity-block .button.plus:hover,
.store-details-block .quantity-block .button.minus:hover,
.store-details-block .quantity-block .button.plus:hover,
.cart-item .quantity-block .button.minus:hover,
.cart-item .quantity-block .button.plus:hover{
  opacity: 0.7;
}
a.edit-email{
  color: var(--primary-color);
}
a.edit-email:hover{
  opacity: 0.7;
}
 .product-short{
   border-color: var(--font-color);
 }
 select.select-product-variant{
    border: 2px solid var(--primary-color) !important;
 }
 .product-detail-wrapper .sizes-section .variant-block .is-checkradio[type="radio"]:checked+label{
   border-color:  var(--primary-color) !important;
 }
  .product-detail-wrapper .sizes-section .variant-block .is-checkradio[type="radio"]:checked+label div{
    color: var(--primary-color) !important;
  }

  .desktop-active-filter-tags ul li,
  .mobile-active-filter-tags ul li{
    border: 2px solid var(--primary-color);
    color: var(--primary-color);
  }

 .loyality-holder-detail{
   border-left: 5px solid var(--primary-color);
 }
 .cart-page .order-summary-block .content-box ::placeholder { 
  color: var(--font-color);;
}
 .cart-page .order-summary-block .content-box :-ms-input-placeholder { 
  color: var(--font-color);;
}
 .cart-page .order-summary-block .content-box ::-ms-input-placeholder { 
  color: var(--font-color);
}
.checkout-wrapper .or-spacer span{
   background-color: var(--secondary-full);
}
.strike:before{
  background: var(--font-color);
}
.cart-sidebar-modal .strike:before{
  background: #333;
}
/* .loyalty-card{
 background-image: linear-gradient(-61deg,  var(--secondary-defined),  var(--secondary-full));
} */
/* .enthusiast-tag{
  background:  var(--secondary-full);
} */
.weed-thc-level .weed-thc-indicator.low span:first-child,
.weed-cbd-level .weed-thc-indicator.low span:first-child{
 background:  var(--primary-color) !important;
}
.weed-thc-level .weed-thc-indicator.medium span:first-child,
.weed-cbd-level .weed-thc-indicator.medium span:first-child,
.weed-thc-level .weed-thc-indicator.medium span:nth-child(2n),
.weed-cbd-level .weed-thc-indicator.medium span:nth-child(2n){
 background:  var(--primary-color) !important;
}
.weed-thc-level .weed-thc-indicator.high span,
.weed-cbd-level .weed-thc-indicator.high span,
.weed-cbd-level .weed-thc-indicator.cbd_dominant span,
.weed-thc-level .weed-thc-indicator.thc_dominant span{
 background:  var(--primary-color) !important;
}
.button.is-fixed-add-to-cart{
  background:  var(--secondary-full);
  border: 1px solid var(--secondary-full);
  color: #FFFFFF;
}
.button.is-fixed-add-to-cart-ouline{
  border: 2px solid var(--secondary-full);
}
.custom-select .items .optionitem:hover{
  color: var(--font-color);
  background:  var(--secondary-full);
}
.custom-select .items,
.custom-select .selected.open{
   border: 2px solid var(--secondary-full);
}
.button.is-fixed-add-to-cart-ouline{
  color: var(--secondary-full);
}
.social-login-signup-wrapper{
  border: 2px solid var(--secondary-full);
}
.social-login-signup-wrapper span{
  color: var(--secondary-full);
}
.text-accent{
  color: var(--accent-color);
}
.border-accent{
  border-color: var(--accent-color) !important;
}
.border-primary{
  border-color: var(--primary-color) !important;
}
ul.recommend-item-variants li,
.display-product-list-type ul li.active{
  background-color: var(--secondary-full);
}
.aromas svg path{
  fill: var(--primary-color);
}

.aroma-border{
  border: 1px solid var(--primary-color);
  padding: 2px;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}
.category-list .category-item a,
.storelanding-page-main .store-landing-shop-categories .category-item a{
  border: 2px solid var(--primary-color);
}
.category-list .category-item.is-active a{
  border: 3px solid var(--primary-color);
}
.storelanding-page-main .store-landing-shop-categories .category-item a span,
.storeprofile-page-main .category-list .category-item a span{
  color: var(--primary-color);;
}
.storelanding-page-main .store-landing-shop-categories .category-item.is-active a span,
.storelanding-page-main .store-landing-shop-categories .category-item a:hover span,
.storeprofile-page-main  .category-list .category-item.is-active a span,
.storeprofile-page-main .category-list .category-item a:hover span,
.storeprofile-page-main .category-list .category-item:hover a span{
  /* color: #fff !important; */
}




.userorderhistory-page-main .tabs li.is-active a:after{
  border-bottom: 5px solid var(--primary-color);
}
.storelocations-page-main .location-search-results .is-active.location-info{
  border-right: 5px solid var(--primary-color);
}
.button:focus, 
.button.is-focused{
  border-color: var(--primary-color) !important;
}
.pg-title-block .history-switch-tab.tabs li.is-active a{
  border-bottom: 3px solid var(--primary-color) !important;
}


.edit-account .is-checkradio[type="radio"]:hover:not([disabled])+label::before, 
.edit-account .is-checkradio[type="radio"]:hover:not([disabled])+label:before, 
.edit-account .is-checkradio[type="checkbox"]:hover:not([disabled])+label::before, 
.edit-account .is-checkradio[type="checkbox"]:hover:not([disabled])+label:before,
.reward-join-now-signup .is-checkradio[type="radio"]:hover:not([disabled])+label::before, 
.reward-join-now-signup .is-checkradio[type="radio"]:hover:not([disabled])+label:before, 
.reward-join-now-signup .is-checkradio[type="checkbox"]:hover:not([disabled])+label::before, 
.reward-join-now-signup .is-checkradio[type="checkbox"]:hover:not([disabled])+label:before,
.checkout-offers .is-checkradio[type="radio"]:hover:not([disabled])+label::before, 
.checkout-offers .is-checkradio[type="radio"]:hover:not([disabled])+label:before, 
.checkout-offers .is-checkradio[type="checkbox"]:hover:not([disabled])+label::before, 
.checkout-offers .is-checkradio[type="checkbox"]:hover:not([disabled])+label:before{
  border-color: var(--primary-color);
}
.my-account-menu-nav ul li:hover a, 
.my-account-menu-nav ul li a.router-link-active, 
.my-account-menu-nav ul li a.router-link-exact-active{
  background: var(--secondary-full);
  color: #fff;
}
.usereditaccount-page-main hr{
  height: 1px;
  background: var(--primary-color);
}
/* .location-product-detail-v2-wrapper .fav-icon.fav-product svg path{
  fill:  var(--primary-color);
} */
.location-product-detail-thccbd .weed-thc-indicator.high span, 
.location-product-detail-thccbd .weed-cbd-indicator.high span,

.location-product-detail-thccbd .weed-thc-indicator.thc_dominant span, 
.location-product-detail-thccbd .weed-cbd-indicator.cbd_dominant span,

.location-product-detail-thccbd .weed-thc-indicator.low span:first-child, 
.location-product-detail-thccbd .weed-cbd-indicator.low span:first-child,
.location-product-detail-thccbd .weed-thc-indicator.medium span:first-child, 
.location-product-detail-thccbd .weed-cbd-indicator.medium span:first-child, 
.location-product-detail-thccbd .weed-thc-indicator.medium span:nth-child(2n), 
.location-product-detail-thccbd .weed-cbd-indicator.medium span:nth-child(2n) {
  background: var(--primary-color) !important;
}
.variant-size-box.active{
  border: 2px solid var(--primary-color);
  color: var(--primary-color);
  background-color: var(--primary-color-light);
}
.tabs li.is-active {
  border-bottom: 2px solid var(--primary-color);
}
.outof-stock-notification-type .is-checkradio[type="radio"]:checked+label::before, 
.outof-stock-notification-type .is-checkradio[type="radio"]:checked+label:before,
.outof-stock-notification-type .is-checkradio[type="radio"]:hover:not([disabled])+label::before, 
.outof-stock-notification-type .is-checkradio[type="radio"]:hover:not([disabled])+label:before{
  border: 0.1rem solid var(--primary-color);
}
.membership-sub-pages-nav ul li.active a,
.membership-sub-pages-nav ul li:hover a{
  background: var(--secondary-full);
  color: #fff;
}
.progress::-webkit-progress-value {
    background-color:var(--secondary-full) ;
}
.progress::-moz-progress-bar {
    background-color:var(--secondary-full) ;
}
.progress::-ms-fill {
    background-color: var(--secondary-full) ;
    border: none;
}
.user-profile .button{
  border-color: var(--secondary-full);
  color: var(--secondary-full);
}
.user-profile .button:hover{
  background-color: var(--secondary-full);
  border-color: var(--secondary-full);
  color: #fff;
}
.checkout-acordions .accordion .accordion-header span.action{
  color: var(--secondary-full);
}
.has-inner-svg-secondary svg path{
  fill: var(--secondary-full);
}
.social-login-signup-icon{
  border-color: var(--secondary-full)  !important;
}
.badge-left-meta{
  border-right: 1px solid var(--secondary-full);
  background-color: var(--secondary-light);
}
.expired .badge-left-meta{
  border-right: 1px solid rgba(0, 0, 0, 0.12);
   background-color: #fff;
}
.expired .badge-left-meta img{
  -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
        -o-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
          filter: grayscale(100%); 
}
.badge-page-item a:hover,
.badge-page-item.active a{
  background-color: var(--secondary-full);
  color: #fff;
}

.badge-detail-content .progress::-webkit-progress-value {
  background-color:  var(--secondary-full);
}

.badge-detail-content .progress::-moz-progress-bar {
  background-color:  var(--secondary-full);
}

.badge-detail-content .progress::-ms-fill {
  background-color:  var(--secondary-full);
  border: none;
}

@media only screen and (max-width: 768px) {
  .edit-profile-link.has-text-dark{
    background-color: var(--primary-color) !important; 
    color: var(--font-color) !important;
  }
  .edit-profile-link.has-text-dark:hover{
    opacity: 0.8;
    color: var(--font-color) !important;
  }
 .button.is-primary:hover{
    opacity: 0.7;
  }
}

</style>

